// extracted by mini-css-extract-plugin
export var featImageClass = "stories-module--featImageClass--YI2t0";
export var imageClass = "stories-module--imageClass--v1KjD";
export var loadMoreBtn = "stories-module--load-more-btn--aqmBO";